type HotkeyEntry = { keys: string; description: string };

const registry = new Map<string, HotkeyEntry>();

export function registerHotkey(keys: string, description: string): void {
  registry.set(keys, { keys, description });
}

export function unregisterHotkey(keys: string): void {
  registry.delete(keys);
}

export function getHotkeys(): HotkeyEntry[] {
  return [...registry.values()];
}
